import { makeAxiosRequest } from 'utils/apiMethods';
import queryString from 'query-string';

export default {
  getPreSignedUrls: (companyId, params) => makeAxiosRequest(
    `/admin/companies/${companyId}/buyer-agreement/s3-pre-signed-urls?${
      queryString.stringify(params, { arrayFormat: 'bracket' })
    }`,
    { method: 'get' },
    true,
  ),
  getBuyerAgreementTemplate: makeAxiosRequest(
    '/buyer-agreement-template',
    {
      method: 'get',
    },
    true,
  ),
};
